<template>
  <vs-tabs>
    <vs-tab label="게시판">
      <div class="tab-text">
        <!-- <div class="vx-row ml-auto cursor-pointer">
          <div style="width:96%;">
            <div align="left" style="margin-left:10px; margin-top:15px;">
              <div class="vx-row">

              </div>
            </div>
          </div>
          <div class="vx-row justify-end">
            <div align="right" style="margin-right:3px; margin-top:15px;">
              <div class="ml-auto cursor-pointer mb-base">
                <feather-icon icon="EditIcon" svg-classes="h-6 w-6" v-if='activeUserLevel >= 2 && activeSpaceInfo.service == true' @click="activePrompt = true" /> &nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
        </div> -->
        <!-- <vs-input icon-pack="feather" color="dark" icon="icon-search" size="large" placeholder="Search" v-model="searchKeywoard" class="is-label-placeholder lg:w-full" /> -->
      <div id="email-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <div class="items-no-padding no-scroll-content border d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

          <!-- SEARCH BAR -->
          <div class="flex border d-theme-dark-bg items-center">
            <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" v-if="activeUserLevel >= 3" @click.stop="test(true)"/>
            <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" v-if="activeUserLevel >= 3 && activeSpaceInfo.service == true" @click.stop="toggleEmailSidebar(true)"/>
            <vs-input icon-no-border icon="icon-search" size="large" icon-pack="feather" placeholder="검색"  v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus w-full" />
          </div>
            <!-- EMAIL ACTION BAR -->
          <div class="email__actions flex items-center flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid d-theme-border-grey-light">
            <div class="flex items-center">
              <vs-checkbox v-if='activeUserLevel >= 2' v-model="userCheckboxVal">내글만</vs-checkbox>
            </div>
            <div class="flex" :click-not-close="clickNotClose" :hidden-background="clickNotClose">
              <feather-icon v-if="activeUserLevel >= 2 && activeSpaceInfo.service == true" icon="EditIcon" class="ml-5 cursor-pointer" svg-classes="h-6 w-6"  @click="activePrompt = true" />
            </div>
          </div>
          <vs-prompt
            class="email-compose"
            title="새글"
            accept-text= "업로드"
            cancel-text= "취소"
            @cancel="clearFields"
            @close="clearFields"
            @accept="createStudentNotice"
            :active.sync="activePrompt">
            <component :is="scrollbarTag" class="scroll-area p-4 mb-6" :settings="settings" :key="$vs.rtl">
              <form @submit.prevent>
                <vs-input name="title" label-placeholder="제목" v-model="title" class="w-full mb-6"/>
                <quill-editor v-model="message" :options="editorOption" style="height:150px;">
                  <div id="toolbar" slot="toolbar">
                    <button class="ql-bold">Bold</button>
                    <button class="ql-italic">Italic</button>
                    <select class="ql-size">
                      <option value="small"></option>
                      <option selected></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                    <select class="ql-font">
                      <option selected="selected"></option>
                      <option value="serif"></option>
                      <option value="monospace"></option>
                    </select>
                    <!-- <button class="ql-video"></button> -->
                  </div>
                </quill-editor>
              </form>
            </component>
          </vs-prompt>
          <component :is="scrollbarTag" class="email-content-scroll-area" :settings="settings" ref="mailListPS" :key="$vs.rtl">
            <transition-group name="list-enter-up" class="email__mails mail__mail-item sm:px-4 px-2 py-6" tag="ul" appear>
              <li class="cursor-pointer email__mail-item" v-for="(studentNotice) in studentNotices" :key="studentNotice.id" @click="updateOpenStudentNotice(studentNotice.id)" >
                <student-notice-item :studentNotice="studentNotice"/>
              </li>
            </transition-group>
          </component>
          <student-notice-view
            :openStudentNoticeId  = "openStudentNoticeId"
            :isSidebarActive = "isSidebarActive"
            @markUnread      = "activePrompt = true"
            @removeMail      = "removeOpenStudentNotice"
            @previousMail    = "previousStudentNotice"
            @nextMail        = "nextStudentNotice"
            @moveTo          = "moveCurrentTo"
            @closeSidebar    = "closeStudentNoticeViewSidebar"/>
        </div>
      </div>
    </div>
  </vs-tab>
    <vs-tab label="수업 질문">
      <NoticeBoard/>
    </vs-tab>
  </vs-tabs>

</template>

<script>
// import StudentNoticeSidebar from "@/views/apps/space/dashboard/StudentNotice/StudentNoticeSidebar.vue"
import StudentNoticeItem from "@/views/apps/space/dashboard/studentNotice/StudentNoticeItem.vue"
import StudentNoticeView from "@/views/apps/space/dashboard/studentNotice/StudentNoticeView.vue"
import moduleStudentNotice from '@/store/studentNotice/moduleStudentNotice.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import NoticeBoard from './NoticeBoard.vue'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  props: ['studentNoticeId'],
  data() {
    return {
      userCheckboxVal       : false,
      searchKeywoard        : '',
      showThread            : false,
      uploadPrompt          : false,
      settings              : {
        maxScrollbarLength  : 60,
        wheelSpeed          : 0.30,
      },
      activePrompt          : false,
      selectedStudentNotice : [],
      openStudentNoticeId   : 0,
      clickNotClose         : true,
      studentNotices        : [],
      title                 : '',
      message               : '',
      isSidebarActive       : false,
      searchQuery           : '',
      editorOption: {
        modules: {
          toolbar: '#toolbar'
        },
      placeholder: '내용을 입력해주세요.'
      },
      card_bg_img_1: require('@/assets/images/pages/faq.jpg')
    }
  },
  computed: {
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    currentStudentNotice() {
      return this.$store.getters['studentNotice/getStudentNotice'](this.openStudentNoticeId)
    },
    studentNoticeList() {
      return this.$store.state.studentNotice.studentNotices
    },
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    activeSpaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    },
  },
  watch: {
    searchQuery(){
      this.$store.commit('studentNotice/SET_NOTICE_SEARCH_QUERY', this.searchQuery)
      this.studentNotices = this.$store.getters['studentNotice/filteredStudentNotice']
    }
  },
  methods: {
    acceptAlert() {
      this.$router.push('/apps/space')
    },
    clearFields() {
      this.$nextTick(() => {
        this.title = ''
        this.message = ''
      })
    },
    createStudentNotice () {
      this.uploadPrompt = true
      this.$store.dispatch('studentNotice/createStudentNotice', {"title": this.title, "workspace_id": this.$store.state.space.ActiveSpaceInfo.id, "detail":this.message}).then(() => {
        this.uploadPrompt = false
        this.studentNotices = this.studentNoticeList
      }).catch(() => {
        this.uploadPrompt = false
        this.$vs.notify({
          color: 'danger',
          title: '에러',
          text: '관리자에게 문의해 주세요.'
        })
      })
      this.clearFields()
    },
    removeOpenStudentNotice() {
      this.selectedStudentNotice = [this.openStudentNoticeId]
      this.isSidebarActive = false
    },
    nextStudentNotice() {
      const currentStudentNoticeIndex = this.studentNoticeList.findIndex((studentNotice) => studentNotice.id == this.openStudentNoticeId)
      if (this.studentNoticeList[currentStudentNoticeIndex + 1]){
        this.openStudentNoticeId = this.studentNoticeList[currentStudentNoticeIndex + 1].id
      }
    },
    previousStudentNotice() {
      const currentStudentNoticeIndex = this.studentNoticeList.findIndex((studentNotice) => studentNotice.id == this.openStudentNoticeId)
      if (this.studentNoticeList[currentStudentNoticeIndex - 1]){
        this.openStudentNoticeId = this.studentNoticeList[currentStudentNoticeIndex - 1].id
      }
    },
    closeStudentNoticeViewSidebar() {
      this.isSidebarActive = false
    },
    moveCurrentTo(to) {
      this.selectedStudentNotice = [this.openStudentNoticeId]
      this.moveTo(to)
    },
    updateOpenStudentNotice(studentNoticeId) {
      this.openStudentNoticeId = studentNoticeId
      this.isSidebarActive = true
    },
    toggleEmailSidebar(value = false) {
      if (!value) {
        this.closeMailViewSidebar()
        if (this.clickNotClose) {
          return
        }
      }
      this.isEmailSidebarActive = value
    },
  },
  components: {
    quillEditor,
    'student-notice-item':StudentNoticeItem,
    StudentNoticeView,
    moduleStudentNotice,
    VuePerfectScrollbar,
    NoticeBoard
  },
  beforeDestroy() {
    this.$store.unregisterModule('studentNotice')
  },
  created() {
    if(this.$route.params.spaceId == 0 && this.$store.state.space.ActiveSpaceInfo.id == 0){
      this.$vs.dialog({
          color: 'danger',
          title: `error`,
          text: 'Workspace 주소가 정확한지 확인해 주세요.',
          accept: this.acceptAlert
        })
      return
    }
    this.$store.registerModule('studentNotice', moduleStudentNotice)
    if(this.$route.params.spaceId == 0){
      this.$route.params.spaceId = this.$store.state.space.ActiveSpaceInfo.id
    }
    if(this.$store.state.space.ActiveSpaceInfo.id != this.$route.params.spaceId){
      this.$store.dispatch('space/getWorkspace', this.$route.params.spaceId).then(()=>{
        this.$store.dispatch('space/getMembers', {'id' : this.$route.params.spaceId}).then(()=>{
          this.$store.commit('space/SET_ACTIVE_USER_LEVEL', this.$store.state.AppActiveUser.uid)
          if(this.activeUserLevel == 0){
            this.$router.push('/pages/accept/id='+this.activeWorkspace.id+'&title='+this.activeWorkspace.title+'&category=[Workspace]')
          }
        })
      })
    }
    this.$store.dispatch('studentNotice/getStudentNotice', this.$route.params.spaceId).then(()=>{
      this.studentNotices = this.$store.state.studentNotice.studentNotices
      if(this.studentNotices.length != 0){
        this.openStudentNoticeId = this.studentNotices[0].id
        if (this.$route.params.stdNoticeId != 0) {
          this.updateOpenStudentNotice(this.$route.params.stdNoticeId)
        }
      }
    })
  },
}
</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

.filebox label {
  text-align: center;
  width:100%;
  display: inline-block;
  padding: .5em .75em;
  color: #000000;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: #E7E7E7;
  cursor: pointer;
  border:  solid #E7E7E7 2px;
  border-radius: .25em;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}

.filebox label:hover {
  background-color: #ffffff;
  border:  solid #E7E7E7 2px;
}

.filebox label:active {
  background-color: #ffffff;
  border:   solid #E7E7E7 2px;
}

.filebox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
#email-app{
    .vs-sidebar--background{
        position: absolute;
    }
    .select-all-chexkbox{
        .vs-checkbox{
            margin-right: 0.8rem;
        }
    }
    .email-filter-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 75px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .email-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 100px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .scroll-area-mail-content {
      position: relative;
      margin: auto;
      width: 100%;
      height: calc(100% - 6.3%);

      &:not(.ps) {
        overflow-y: auto;
      }
    }

    .email__mails {
        .mail__opened-mail {
            background-color: #eee;
        }
    }


    .email__mails {

        .email__mail-item {
            transition: all .35s;

            &:not(:first-of-type) {
                .mail__mail-item {
                    border-top: 1px solid #dae1e7;
                }
            }

            .mail__mail-item {
                transition: all 0.2s;


                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0px 3px 10px 0px #ccc;
                    transition: all 0.2s;
                }

                // Star icon color
                .feather-icon {
                    color: #9c9c9c;
                }
            }
        }
    }

    .email-view-sidebar {
        .vs-sidebar{
            background-color: #f8f8f8 !important;
            border-left: 1px solid #dae1e7;
        }

        .email-header{
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
            border-bottom: 1px solid #eee;
            z-index: 1;
            position: relative;
        }

        .open-mail-label {
            transition: all .35s;
        }

        .mail__attachment {
          .vs-chip--text {
            margin-left: 0;
            margin-right: 0;
          }
        }
    }
}


// COMPOSE MAIL DIALOG
.con-vs-dialog.email-compose {
    .vs-dialog {
        max-width: 730px;
        // max-height: 95vh;

        .vs-dialog-text {
            padding: 0;

            .scroll-area {
                max-height: 75vh;

                &:not(.ps) {
                  overflow-y: auto;
                }
            }

            .compose-mail-attachment {
              .con-input-upload {
                margin: 0;
              }
            }
        }
    }

    .con-img-upload {

    .con-input-upload {
      height: 2.5rem;
      width: 100%;
    }

        .img-upload {
            // height: 4rem;
            margin: 0;
            margin-bottom: .5rem;
            margin-right: 1.5rem;
        }
    }

    .quill-editor {
        margin-bottom: 1.5rem
    }

    .ql-editor {
        height: 150px;
    }
}

</style>
